import React from 'react'
import { shallow, mount } from 'enzyme'
import { UserProvider } from 'context/UserContext'
import { QueryParamProvider, transformSearchStringJsonSafe } from 'use-query-params'
import { Route, BrowserRouter as Router } from 'react-router-dom'
import { HeaderProvider } from 'app/header/HeaderContext'
import IpAddressList from '../index.jsx'

const queryStringifyOptions = {
  transformSearchString: transformSearchStringJsonSafe,
}

jest.mock('@fortressiq/fiq-ds', () => ({
  useNotification: () => ({
    addNotification: jest.fn(),
  }),
  useModal: () => ({
    addModal: jest.fn(),
    removeModal: jest.fn(),
  }),
  useFela: () => ({
    css: jest.fn(),
    theme: {
      'default-spacer-md': '16px',
      white: '#fff',
    },
  }),
  Button: ({ children, ...props }) => (
    <button type='button' {...props}>
      {children}
    </button>
  ),
  SwitchSection: ({ label, onSwitch, ...props }) => (
    <div {...props}>
      <label>{label}</label>
      <input type='checkbox' onChange={() => onSwitch({ SWITCH_STATE: !props.checked })} />
    </div>
  ),
  Typography: { Text: ({ textToCopy }) => <span>{textToCopy}</span> },
  theme: { 'default-spacer-md': '16px', white: '#fff' },
  Badge: ({ status }) => <span>{status}</span>,
  Popconfirm: ({ children, onConfirm }) => (
    <div>
      {children}
      <button type='button' onClick={onConfirm}>
        Confirm
      </button>
    </div>
  ),
}))

jest.mock('axios', () => ({
  get: jest.fn(() => Promise.resolve({ data: { msg: 'Success' } })),
  post: jest.fn(() => Promise.resolve({ data: { url: 'http://example.com' } })),
  put: jest.fn(() => Promise.resolve({ data: { active: false } })),
  patch: jest.fn(() => Promise.resolve({ data: true })),
}))

jest.mock('lib/Api', () => ({
  post: jest.fn(() => Promise.resolve({ data: { url: 'http://example.com' } })),
  put: jest.fn(() => Promise.resolve({ data: { active: false } })),
  patch: jest.fn(() => Promise.resolve({ data: true })),
}))

jest.mock('components/TrinityTable')

describe('IpAddressList Component', () => {
  it('should match snapshot', () => {
    const wrapper = shallow(
      <UserProvider init={{ roleNames: 'superuser' }}>
        <HeaderProvider>
          <IpAddressList />
        </HeaderProvider>
      </UserProvider>
    )
    expect(wrapper).toMatchSnapshot()
  })

  it('should render without crashing', () => {
    const wrapper = mount(
      <UserProvider init={{ roleNames: 'superuser' }}>
        <HeaderProvider>
          <Router>
            <QueryParamProvider ReactRouterRoute={Route} stringifyOptions={queryStringifyOptions}>
              <IpAddressList />
            </QueryParamProvider>
          </Router>
        </HeaderProvider>
      </UserProvider>
    )
    expect(wrapper.exists()).toBe(true)
  })
})
